import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/* `window.matchMedia`, or null where it is unavailable  */
function mediaQueryList(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(query);
}

export function useMediaQuery(query: string, defaultValue = false): boolean {
  const [matches, setMatches] = useState(() => mediaQueryList(query)?.matches ?? defaultValue);

  useEffect(() => {
    const mql = mediaQueryList(query);
    if (!mql) return;

    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    mql.addEventListener('change', onChange);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}

/** The exact complement of `useIsMobile` — never both false, never both true. */
export function useIsDesktop(): boolean {
  return !useIsMobile();
}
